import SlimSelect from 'slim-select';

export default class NavigationLanguageController {
  private countrySelectElement = document.querySelector('#country-select');
  private languageSelectElements: NodeListOf<HTMLSelectElement> = document.querySelectorAll('.js-language-select');
  private languageNavDropdown = document.querySelector('.js-language-navigation-dropdown');
  private mobileOpenButton = document.querySelector('.js-languageNavMobileButton');
  private searchNavDropdown = document.querySelector('.js-search-navigation-dropdown');
  private mobileOpenButtonSearch = document.querySelector('.js-searchNavMobileButton');
  private desktopOpenButtonSearch = document.querySelector('.js-searchNavDesktopButton');
  private desktopSearchButton = document.querySelector('.js-searchButton');
  private desktopOpenLangDropdown = document.querySelector('.js-langDropdownDesktopButton');
  private desktopCurrentLang = document.querySelector('.js-currentLanguage');

  constructor() {
    this.initSelects();
    this.initMobile();
    this.initDesktop();
  }

  initSelects() {
    const countrySelect = new SlimSelect({
      select: '#country-select',
      showSearch: false,
      placeholder: (document.querySelector('#country-select') as HTMLElement).dataset.placeholdertext || 'Select region/country',
    });
    const languageSelectEu = new SlimSelect({
      select: '#language-select-eu',
      showSearch: false,
      placeholder: (document.querySelector('#language-select-eu') as HTMLElement).dataset.placeholdertext || 'Select language',
    });
    const languageSelectUs = new SlimSelect({
      select: '#language-select-us',
      showSearch: false,
      placeholder: (document.querySelector('#language-select-us') as HTMLElement).dataset.placeholdertext || 'Select language',
    });
    const languageSelectCn = new SlimSelect({
      select: '#language-select-cn',
      showSearch: false,
      placeholder: (document.querySelector('#language-select-cn') as HTMLElement).dataset.placeholdertext || 'Select language',
    });
    const languageSelectJp = new SlimSelect({
      select: '#language-select-jp',
      showSearch: false,
      placeholder: (document.querySelector('#language-select-jp') as HTMLElement).dataset.placeholdertext || 'Select language',
    });
    const languageSelectKr = new SlimSelect({
      select: '#language-select-kr',
      showSearch: false,
      placeholder: (document.querySelector('#language-select-kr') as HTMLElement).dataset.placeholdertext || 'Select language',
    });

    this.countrySelectElement?.addEventListener('change', () => {
      for (let i = 0; i < this.languageSelectElements.length; i++) {
        this.languageSelectElements[i].classList.add('hide');
      }
      let selectToShow = document.querySelector(countrySelect.selected() as string);
      if (selectToShow) {
        selectToShow.classList.remove('hide');
      }
    });

    for (let i = 0; i < this.languageSelectElements.length; i++) {
      this.languageSelectElements[i].addEventListener('change', () => {
        window.location.href = this.languageSelectElements[i].value;
      });
    }
  }

  initDesktop() {
    this.desktopSearchButton?.addEventListener('click', () => {
      this.desktopOpenButtonSearch?.classList.toggle('headerSearchWrapper--open');
      this.desktopOpenLangDropdown?.classList.remove('languageNavigation--open');
    });

    window.addEventListener('resize', () => {
      this.desktopOpenButtonSearch?.classList.remove('headerSearchWrapper--open');
    });

    this.desktopCurrentLang?.addEventListener('click', () => {
      this.desktopOpenLangDropdown?.classList.toggle('languageNavigation--open');
      this.desktopOpenButtonSearch?.classList.remove('headerSearchWrapper--open');
    });

    window.addEventListener('resize', () => {
      this.desktopOpenLangDropdown?.classList.remove('languageNavigation--open');
    });
  }

  initMobile() {
    this.mobileOpenButtonSearch?.addEventListener('click', () => {
      this.searchNavDropdown?.classList.toggle('searchNavigation__dropdown--open');
      this.mobileOpenButtonSearch?.classList.toggle('searchNavigation__dropdown--hover');
      this.languageNavDropdown?.classList.remove('languageNavigation__dropdown--open');
    });

    window.addEventListener('resize', () => {
      this.searchNavDropdown?.classList.remove('searchNavigation__dropdown--open');
      this.mobileOpenButtonSearch?.classList.remove('searchNavigation__dropdown--hover');
    });

    this.mobileOpenButton?.addEventListener('click', () => {
      this.languageNavDropdown?.classList.toggle('languageNavigation__dropdown--open');
      this.searchNavDropdown?.classList.remove('searchNavigation__dropdown--open');
      this.mobileOpenButtonSearch?.classList.remove('searchNavigation__dropdown--hover');
    });

    window.addEventListener('resize', () => {
      this.languageNavDropdown?.classList.remove('languageNavigation__dropdown--open');
    });
  }
}
